import { FC, ReactElement, useId } from 'react';

import { Loader } from '@pp/core/src/components/loader/Loader';

import { useRecentResultFetcher } from '../../../../store/apiHooks/useRecentResultFetcher';
import { useGameDispatch } from '../../../../store/GameStore';
import { useHighflyerGameStateSlice } from '../../../../store/slices/highflyerGame/selectors';
import { highflyerGameStateActions } from '../../../../store/slices/highflyerGame/slice';
import TimerButton from '../../../recentResultDetail/timer/TimerButton';
import { SingleResult } from '../../../recentResults/singleResult';
import { ErrorMessage } from '../../errorMessage/ErrorMessage';
import { ScrollableWrapper } from '../../scrollableWrapper/ScrollableWrapper';

import styles from './StatsLastResults.module.css';

export const StatsLastResults: FC = () => {
  const id = useId();
  const dispatch = useGameDispatch();
  const recentResultFetcher = useRecentResultFetcher(true);
  const isApiRejected = useHighflyerGameStateSlice.getIsLastResultDataFetched();
  const recentResults = useHighflyerGameStateSlice.getTableStatsResult()?.history;
  const showInPlayTimerButton = useHighflyerGameStateSlice.timerInPlayBtnStatus();

  return (
    <ScrollableWrapper>
      {((): ReactElement => {
        if (isApiRejected && !recentResults) {
          return (
            <ErrorMessage
              title="HIGHFLYER_FAILED_TO_LOAD"
              message="HIGHFLYER_INTERNAL_ERROR"
              disabled={false}
              loading={false}
              onClick={(): void => {
                dispatch(highflyerGameStateActions.setIsLastResultError());
                recentResultFetcher();
              }}
            />
          );
        } else if (!isApiRejected && !recentResults) {
          return <Loader />;
        } else {
          return (
            <div className={styles.tableStats_lastResult_container}>
              {showInPlayTimerButton && (
                <div className={styles.onHover}>
                  <TimerButton />
                </div>
              )}
              {recentResults?.map((result, index) => (
                <div className={styles.onHover} key={`recent-result-${id}`}>
                  <SingleResult
                    key={`single-result-${id}`}
                    active={index === 0}
                    type={result.gameResult}
                    value={result.gameResult}
                  />
                </div>
              ))}
            </div>
          );
        }
      })()}
    </ScrollableWrapper>
  );
};
